import get from 'lodash/get';
// Image Refs
import shelfInstall from 'src/images/qaflow/shelf_install.png';
import soundbarInstall from 'src/images/qaflow/soundbar_install.png';
import surfaceBrick from 'src/images/qaflow/surface_brick.png';
import surfaceDrywall from 'src/images/qaflow/surface_drywall.png';
import surfaceFireplace from 'src/images/qaflow/surface_fireplace.png';
import otherSurface from 'src/images/qaflow/other_surface.png';
import tvLarge from 'src/images/qaflow/tv_large.png';
import tvMedium from 'src/images/qaflow/tv_medium.png';
import tvSmall from 'src/images/qaflow/tv_small.png';
import wallmountFixed from 'src/images/qaflow/wallmount_fixed.png';
import mountReady from 'src/images/qaflow/mount_ready.png';
import wallmountFullmotion from 'src/images/qaflow/wallmount_fullmotion.png';
import wallmountTilt from 'src/images/qaflow/wallmount_tilt.png';
// Constants
import { SKU_CONFIG_IDS } from 'src/containers/AddSkuPage/QuestionsFlowPage/skudata/constants';
import { CHECKBOX, RADIO, TEXTAREA, QA_FLOW_ANSWER_LAYOUTS } from '../constants';

const sku = SKU_CONFIG_IDS[879];

const SIZE_INFO = Object.freeze({
  // May not need the qid and answers, but leaving for now -GH Sep 22, 2021
  [sku[14046]]: {
    label: 'Up to 32"',
    value: 'Base',
    preQuestion: { qid: 1419, answers: { id: 4100 } },
  },
  [sku[14047]]: {
    label: '33" - 60"',
    value: 70,
    preQuestion: { qid: 1419, answers: { id: 4101 } },
  },
  [sku[14048]]: {
    label: '61" or larger',
    value: 100,
    preQuestion: { qid: 1419, answers: { id: 4102 } },
  },
});

/**
 * PANEL CONTENT - ADDITIONAL
 *
 * ADDITIONAL INFO:
 * This is used to pass into the components so they know what data they can "expand" on in their view.
 * ie.. add an icon, content, image, etc..
 *
 * This is the info "in" the panel proper.
 *
 * The ADDITIONAL_INFO key will match the answer key it is associated with. They should match.
 *
 * I KNOW THIS is a little goofy to "break out", but rather than create giant data structures in answer, I just put it
 * here so we can keep things a little neater. It is also something you have to "update" when you update the answer keys,
 * take a hit for upkeep, but make things a little neater.....scales of justice :-)
 *
 * I entry for every Question Set
 */
const ADDITIONAL_INFO = {
  // Size of TV product
  [sku[14046]]: { additionalInfo: { imageRef: tvSmall, content: '' } },
  // 11167: { additionalInfo: { imageRef: tvSmall, content: '' } },
  [sku[14047]]: {
    additionalInfo: { imageRef: tvMedium, content: '' },
  },
  [sku[14048]]: { additionalInfo: { imageRef: tvLarge, content: '' } },

  // Type of Mount sku[5753]
  [sku[14059]]: { additionalInfo: { imageRef: mountReady, content: '' } },
  [sku[14060]]: {
    additionalInfo: {
      imageRef: wallmountFixed,
      content: '',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14060]],
    },
  },
  [sku[14172]]: {
    additionalInfo: {
      imageRef: wallmountTilt,
      content: '',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14172]],
    },
  },
  [sku[14173]]: {
    additionalInfo: {
      imageRef: wallmountFullmotion,
      content: '',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14173]],
    },
  },

  // lift TV 5751
  [sku[14053]]: { additionalInfo: {} },
  [sku[14054]]: { additionalInfo: {} },

  // Remove TV sku[5752]
  [sku[14055]]: {
    showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14055]],
  },
  [sku[14056]]: {},

  // type of surface sku[5750]
  [sku[14049]]: {
    additionalInfo: {
      imageRef: surfaceDrywall,
      content: '',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14049]],
    },
  },
  [sku[14050]]: {
    additionalInfo: {
      imageRef: surfaceBrick,
      content: '',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14050]],
    },
  },
  [sku[14051]]: {
    additionalInfo: {
      imageRef: surfaceFireplace,
      content: 'We only mount on drywall surfaces',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14051]],
    },
  },
  [sku[14052]]: {
    additionalInfo: {
      imageRef: otherSurface,
      content: '',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14052]],
    },
  },

  // Cord Concealment
  [sku[14068]]: {
    additionalInfo: {
      imageRef: '',
      content: '',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14068]],
    },
  },
  [sku[14064]]: {
    additionalInfo: {
      imageRef: '',
      content: 'I have my own parts',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14064]],
    },
  },
  [sku[14065]]: {
    additionalInfo: {
      imageRef: '',
      content: 'Tech will bring parts',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14065]],
    },
  },
  [sku[14066]]: {
    additionalInfo: {
      imageRef: '',
      content: 'I have my own parts',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14066]],
    },
  },
  [sku[14067]]: {
    additionalInfo: {
      imageRef: '',
      content: 'Tech will bring parts',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14067]],
    },
  },

  // anthing else sku[5755]
  [sku[14069]]: {
    additionalInfo: {
      imageRef: soundbarInstall,
      content: 'You must provide your own soundbar and mounting hardware.',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14069]],
    },
  },
  [sku[14070]]: {
    additionalInfo: {
      imageRef: shelfInstall,
      content:
        'Your tech can install simple shelving that requires minimal assembly. You must provide your own shelves and hardware.',
      showModal: () => ADDITIONAL_INFO_MODAL_DISPLAYS[sku[14070]],
    },
  },
};

/**
 *  ANSWERS
 *
 *  List all answers here
 *
 *  OUR DECISION is fairly base. We seperated it out in answers and the decisionTree.
 *  Our decision tree will merge answer behaviors w/ the answer proper. Any overrides will happen in
 *  the decision tree.
 *  1. Add any 'new' answers
 *     i. if same answer id's have different values, that is ok, the tree will handle the override in the groups.
 *  2. Apply that answer to a question. What group is it part of? No seperate groups will default to group A.
 *
 */
export const answers = {
  // Size of TV product 5749
  [sku[14046]]: { id: sku[14046], ...SIZE_INFO[sku[14046]], ...ADDITIONAL_INFO[sku[14046]] },
  [sku[14047]]: { id: sku[14047], ...SIZE_INFO[sku[14047]], ...ADDITIONAL_INFO[sku[14047]] },
  [sku[14048]]: { id: sku[14048], ...SIZE_INFO[sku[14048]], ...ADDITIONAL_INFO[sku[14048]] },

  // type of surface sku[5750]
  [sku[14049]]: {
    id: sku[14049],
    label: 'Drywall',
    value: '',
    priceDisplay: 'Base',
    ...ADDITIONAL_INFO[sku[14049]],
  },
  [sku[14050]]: {
    id: sku[14050],
    label: 'Brick/Concrete',
    value: 69,
    ...ADDITIONAL_INFO[sku[14050]],
  },
  [sku[14051]]: {
    id: sku[14051],
    label: 'Above Fireplace',
    value: 69,
    ...ADDITIONAL_INFO[sku[14051]],
  },
  [sku[14052]]: {
    id: sku[14052],
    label: 'Other Surfaces',
    value: '',
    ...ADDITIONAL_INFO[sku[14052]],
  },

  // lift TV sku[5751]
  [sku[14053]]: { id: sku[14053], label: 'Yes', value: '' },
  [sku[14054]]: { id: sku[14054], label: 'No, please bring assistance', value: '' },

  // Remove TV sku[5752]
  [sku[14055]]: {
    id: sku[14055],
    label: 'Yes',
    value: 79,
    ...ADDITIONAL_INFO[sku[14055]],
  },
  [sku[14056]]: {
    id: sku[14056],
    label: 'No',
    ...ADDITIONAL_INFO[sku[14056]],
  },

  // Type of Mount sku[5753]
  [sku[14059]]: {
    id: sku[14059],
    label: 'I have my own mount ready',
    ...ADDITIONAL_INFO[sku[14059]],
  },
  [sku[14060]]: {
    id: sku[14060],
    label: 'Fixed Mount',
    value: 79,
    ...ADDITIONAL_INFO[sku[14060]],
  },
  [sku[14172]]: {
    id: sku[14172],
    label: 'Tilting Mount',
    value: 79,
    ...ADDITIONAL_INFO[sku[14172]],
  },
  [sku[14173]]: {
    id: sku[14173],
    label: 'Full Motion Mount',
    value: 99,
    ...ADDITIONAL_INFO[sku[14173]],
  },

  // Cord Concealment sku[5754]
  [sku[14064]]: {
    id: sku[14064],
    label: 'In-Wall Cord Concealment Labor Only',
    value: 69,
    ...ADDITIONAL_INFO[sku[14064]],
  },
  [sku[14065]]: {
    id: sku[14065],
    label: 'In-Wall Cord Concealment Labor + Parts',
    value: 149,
    ...ADDITIONAL_INFO[sku[14065]],
  },
  [sku[14066]]: {
    id: sku[14066],
    label: 'External Cord Masking Labor Only',
    value: 29,
    ...ADDITIONAL_INFO[sku[14066]],
  },
  [sku[14067]]: {
    id: sku[14067],
    label: 'External Cord Masking Labor + Parts',
    value: 39,
    ...ADDITIONAL_INFO[sku[14067]],
  },
  [sku[14068]]: { id: sku[14068], label: 'Leave cords as is', value: '' },

  // anthing else sku[5755]
  [sku[14069]]: {
    id: sku[14069],
    label: 'Mount a Soundbar',
    value: 59,
    ...ADDITIONAL_INFO[sku[14069]],
  },
  [sku[14070]]: {
    id: sku[14070],
    label: 'Install Basic Shelves',
    value: 49,
    ...ADDITIONAL_INFO[sku[14070]],
  },
  // Any additional comments or concerns? sku[5756]
  [sku[14071]]: {
    id: sku[14071],
  },
};

// This takes the id, and grabs some things that will always be consistent across references.
// ie. image ref? label (answer label)
const referenceNeedAssets = (id) => {
  return {
    imageRef: get(ADDITIONAL_INFO, [id, 'additionalInfo', 'imageRef'], ''),
    label: get(answers, [id, 'label'], ''),
  };
};
/**
 * MODAL CONTENT
 *
 * We match our display request via icon click. Match up the answer id, and
 * find it here too display. Only show if there is corresponding entry.
 *
 * This is the data IN the modals (borrowed from ADDITIONAL_INFO & answers)
 *
 * 1 entry for every Question that needs a modal. Don't conflate this if there is no need for a modal.
 */
export const ADDITIONAL_INFO_MODAL_DISPLAYS = {
  // Type of Mount sku[5753]
  [sku[14060]]: {
    ...referenceNeedAssets(sku[14060]),
    content:
      'Fixed mounts offer a low-profile way to mount your TV flush against a wall. Doesn’t allow for any movement or angle adjustment.',
  },
  [sku[14172]]: {
    ...referenceNeedAssets(sku[14172]),
    content:
      'Tilting mounts allow you to adjust the vertical angle of the TV, which works well for TVs mounted above typical viewing levels.',
  },
  [sku[14173]]: {
    ...referenceNeedAssets(sku[14173]),
    content:
      'Full-motion mounts offer tilting, side-to-side swiveling, as well as folding arms to adjust the TV’s distance from the wall.',
  },

  // type of surface sku[5750]
  [sku[14049]]: {
    ...referenceNeedAssets(sku[14049]),
    content: 'Drywall makes a hollow, airy sound when you knock on it. Give it a try!',
  },
  [sku[14050]]: {
    ...referenceNeedAssets(sku[14050]),
    content:
      'Brick and concrete walls make a dense, hard sound with no echo when you knock on them. Give it a try!',
  },
  [sku[14051]]: {
    ...referenceNeedAssets(sku[14051]),
    content:
      'For safety reasons, we require that the mounting surface above your fireplace be drywall. We will not mount to any other type of surface.',
  },
  [sku[14052]]: {
    ...referenceNeedAssets(sku[14052]),
    content:
      "If your surface isn't mentioned or you're just not sure, that's OK! Your technician will figure it out and adjust as needed.",
  },

  // take down tv
  [sku[14055]]: {
    ...referenceNeedAssets(sku[14049]),
    content:
      'If your new TV mount will replace your existing setup, our technicians will need to take down your current TV.',
  },

  // Cord Concealment
  [sku[14064]]: {
    ...referenceNeedAssets(sku[14064]),
    content:
      "We'll route your cables behind the wall, keeping them completely out of sight. For safety reasons, we require a drywall surface for concealing cords in-wall.",
  },
  [sku[14065]]: {
    ...referenceNeedAssets(sku[14065]),
    content:
      "We'll route your cables behind the wall, keeping them completely out of sight. For safety reasons, we require a drywall surface for concealing cords in-wall.",
  },
  [sku[14066]]: {
    ...referenceNeedAssets(sku[14066]),
    content:
      'Your cords will be neatly organized and routed through a discrete housing, typically mounted with adhesive.',
  },
  [sku[14067]]: {
    ...referenceNeedAssets(sku[14067]),
    content:
      'Your cords will be neatly organized and routed through a discrete housing, typically mounted with adhesive.',
  },

  // anthing else sku[5755]
  [sku[14069]]: {
    ...referenceNeedAssets(sku[14069]),
    content: 'You must provide your own soundbar and mounting hardware.',
  },
  [sku[14070]]: {
    ...referenceNeedAssets(sku[14070]),
    content:
      'Your tech can install simple shelving that requires minimal assembly. You must provide your own shelves and hardware.',
  },
};

/**
 *  Decision Tree
 *
 *  Answers will live under 'children', slotted into a group. Default is A.
 *  Spread out the needed answers, and add:
 *  @param answerType - RADIO, CHECKBOX
 *  @param path - this is the question id the answer links to
 *  @param group - if there is a specific group within a question to link to.
 */
export const decisionTree = () => ({
  seedQuestion: sku[5749],
  additonalInfo: ADDITIONAL_INFO_MODAL_DISPLAYS,
  maxFlow: 7,
  [sku[5749]]: {
    id: sku[5749],
    label: 'What size is your TV?',
    hint: 'The size of your TV is measured diagonally from corner to corner.',
    answerType: RADIO,
    children: {
      A: [
        { ...answers[sku[14046]], path: sku[5750] },
        { ...answers[sku[14047]], path: sku[5750] },
        { ...answers[sku[14048]], path: sku[5750] },
      ],
    },
  },
  [sku[5750]]: {
    // What type of surface
    id: sku[5750],
    label: 'What type of surface will your TV be mounted to?',
    answerType: RADIO,
    alert: {
      title: 'Important',
      content: 'We do not  mount on plaster, tile, or stone facades.',
    },
    children: {
      A: [
        { ...answers[sku[14049]], path: sku[5751] },
        { ...answers[sku[14050]], path: sku[5751] },
        { ...answers[sku[14051]], path: sku[5751] },
        { ...answers[sku[14052]], path: sku[5751] },
      ],
    },
  },
  [sku[5751]]: {
    // lift the TV?
    id: sku[5751],
    label: 'Can you help your technician lift the TV',
    hint:
      'If you aren’t available or able to lift the TV, your tech will be informed to bring assistance.',
    alert: undefined,
    answerType: RADIO,
    children: {
      A: [
        { ...answers[sku[14053]], path: sku[5752] },
        { ...answers[sku[14054]], path: sku[5752] },
      ],
    },
  },
  [sku[5752]]: {
    // Take down TV
    id: sku[5752],
    label: 'Do you need to take down your current TV?',
    hint:
      'Your tech can take down your current setup, or you can save time and money by doing it ahead of time.',
    alert: undefined,
    answerType: RADIO,
    children: {
      A: [
        { ...answers[sku[14055]], path: sku[5753] },
        { ...answers[sku[14056]], path: sku[5753] },
      ],
    },
  },
  [sku[5753]]: {
    // What type of mount
    id: sku[5753],
    label: 'Do you need a wall mount for your TV?',
    hint: 'If you need a mount, your technician can bring one to your appointment.',
    answerType: RADIO,
    alert: undefined,
    children: {
      A: [
        { ...answers[sku[14059]], path: sku[5754] },
        { ...answers[sku[14060]], path: sku[5754] },
        { ...answers[sku[14172]], path: sku[5754] },
        { ...answers[sku[14173]], path: sku[5754] },
      ],
    },
  },
  [sku[5754]]: {
    // Cords Concealed perhaps "sku[5755]"?
    id: sku[5754],
    label: 'How should we handle the cords?',
    hint: 'Your tech can bring the required parts to your appointment if requested.',
    answerType: RADIO,
    alert: {
      title: 'Important',
      content: 'In-wall cord concealment is not available for surfaces above a fireplace, or brick',
    },
    children: {
      A: [
        { ...answers[sku[14064]], path: sku[5755] },
        { ...answers[sku[14065]], path: sku[5755] },
        { ...answers[sku[14066]], path: sku[5755] },
        { ...answers[sku[14067]], path: sku[5755] },
        { ...answers[sku[14068]], path: sku[5755] },
      ],
    },
  },

  [sku[5755]]: {
    // anthing else
    id: sku[5755],
    label: 'Anything else we can help you with?',
    hint: 'Please have all parts and hardware ready for your tech to install any additional items.',
    answerType: CHECKBOX,
    layout: QA_FLOW_ANSWER_LAYOUTS.ROW,
    required: false,
    defaultPath: sku[5756], //  <--- WHATEVER THE NEXT PATH ID IS
    children: {
      A: [
        { ...answers[sku[14069]], path: sku[5756] },
        { ...answers[sku[14070]], path: sku[5756] },
      ],
    },
  },

  [sku[5756]]: {
    // Any Other Concerns
    id: sku[5756],
    label: 'Any additional comments or concerns?',
    hint: 'Leave a note for your tech or include information not covered.',
    answerType: TEXTAREA,
    complete: true,
    children: {
      A: [{ ...answers[sku[14071]], path: null, complete: true }],
    },
  },
});
